import { observer } from 'mobx-react-lite';
import type { JSX } from 'react';
import React from 'react';
import { useTranslation } from 'react-i18next';

import { Heading } from '@feathr/components';
import Page from '@feathr/extender/App/Page';

function APIKeysPage(): JSX.Element {
  const { t } = useTranslation();

  return (
    <Page title={t('API Keys')}>
      <Heading order={3} variant={'h3'}>
        {t('API Keys')}
      </Heading>
    </Page>
  );
}

export default observer(APIKeysPage);
